export default "__VITE_ASSET__C005uyUA__"